export const SURVEY_TYPE = {
  AIMI: 'aimi',
  ASSESSMENT: 'assessment',
};

// Only these survey types get a badge next to the survey title.
export const SURVEY_TYPE_TOOLTIP: ReadonlyMap<string, string> = new Map([
  [SURVEY_TYPE.AIMI, 'This survey is AI moderated.'],
  [SURVEY_TYPE.ASSESSMENT, 'This survey is an assessment.'],
]);
